<div class="input-group d-inline-flex align-items-center" [ngClass]="{ 'multiline-text': modelType !== 'TextModel' }">
    <input
        *ngIf="modelType === 'TextModel'"
        type="text"
        #textInput
        [formControl]="textInputControl"
        [placeholder]="model.options.placeholder"
        [attr.inputmode]="inputMode || model.options.inputType"
        (blur)="onBlur()"
        (focus)="onFocus()"
        paceCoreTextInputRestriction
        class="form-control input-md text-input"
        paceCoreValidationMessage
        [validation]="textInputControl"
        [attr.aria-label]="ariaLabel"
    />
    <textarea
        *ngIf="modelType === 'MultilineTextModel'"
        class="form-control input-md text-input"
        #textAreaInput
        [formControl]="textInputControl"
        [placeholder]="model.options.placeholder"
        (blur)="onBlur()"
        paceCoreTextInputRestriction
        cols="{{ model.options.columns }}"
        rows="{{ model.options.rows }}"
        paceCoreValidationMessage
        [validation]="textInputControl"
        [attr.aria-label]="ariaLabel"
    >
    </textarea>
    <textarea
        *ngIf="modelType === 'InternalInfoMultilineTextModel'"
        class="form-control input-md text-input"
        #internalInfoTextAreaInput
        [formControl]="textInputControl"
        [placeholder]="model.options.placeholder"
        (blur)="onBlur()"
        paceCoreTextInputRestriction
        cols="{{ model.options.columns }}"
        rows="{{ model.options.rows }}"
        paceCoreValidationMessage
        [validation]="textInputControl"
        [attr.aria-label]="ariaLabel"
    >
    </textarea>
    <ng-container *ngIf="model.options.scannable">
        <button
            id="scan-btn"
            class="btn btn-secondary"
            [disabled]="model.options.readonly"
            type="button"
            (click)="doScan()"
            [attr.aria-label]="'BARCODE_SCANNER_SET_TITLE' | translate"
        >
            <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
        </button>
    </ng-container>
    <div *ngIf="model.options.unit" id="unit">
        <span class="input-group-text">{{ model.options.unit }}</span>
    </div>
</div>
